import React from 'react'

import { render, reset } from './actions'

import { TCreateModal } from './types'

export default function createModal(
  Modal: React.ElementType<TCreateModal>,
  props?: {}
) {
  function display({ onSubmit, onDismiss }) {
    render(<Modal onSubmit={onSubmit} onDismiss={onDismiss} {...props} />)
  }

  function hide() {
    reset()
  }

  const handler = new Promise((resolve) => {
    const onSubmit = (value = true) => resolve(value)
    const onDismiss = () => resolve(undefined)

    display({ onSubmit, onDismiss })
  })

  return handler.finally(() => {
    hide()
  })
}
